import { Injectable } from "@angular/core";
import { SaveWhatsappUsecase } from "@arch/domain/application/usecase/save-whatsapp.usecase";
import { AccountingType } from "@arch/domain/entity/accounting.entity";

@Injectable({
    providedIn: "root"
})
export class SaveWhatsappController {
    constructor(readonly saveWhatsappUsecase: SaveWhatsappUsecase) {}

    public async execute(input: AccountingType): Promise<void> {
        await this.saveWhatsappUsecase.execute(input);
    }
}
